import type { TabDetailsProps } from '..';
import { PermittingRequestForm } from './PermittingRequestForm';

export function TabDetails(_props: TabDetailsProps) {
  return (
    <div className="box-border min-h-0 flex-1 px-4 py-2">
      <PermittingRequestForm />
    </div>
  );
}
